import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "pb-8 pb-lg-10" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark" }, "Upload Documents")
], -1)
const _hoisted_3 = { class: "fv-row mb-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required mb-10" }, [
  /*#__PURE__*/_createTextVNode("Upload the "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, [
    /*#__PURE__*/_createElementVNode("b", null, "front")
  ]),
  /*#__PURE__*/_createTextVNode(" of your document")
], -1)
const _hoisted_5 = {
  class: "w-100 h-350px image-input image-input-outline",
  "data-kt-image-input": "true",
  style: {"background-image":"url(media/avatars/blank.png)"}
}
const _hoisted_6 = { class: "d-flex p-2 justify-content-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  class: "d-flex justify-content-center h-300px w-350px"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-file-image" })
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, [
  /*#__PURE__*/_createTextVNode(" Upload the "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, [
    /*#__PURE__*/_createElementVNode("b", null, "front")
  ]),
  /*#__PURE__*/_createTextVNode(" of your document ")
], -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  class: "btn btn-icon btn-circle btn-active-color-primary bg-white shadow",
  "data-kt-image-input-action": "change",
  "data-bs-toggle": "tooltip",
  title: "Change avatar",
  ref: "frontRef"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-fill fs-7" }, null, -1)
const _hoisted_14 = ["value"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  name: "avatar_remove"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x fs-2" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 0,
  class: "fv-row mb-10"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required mb-10" }, [
  /*#__PURE__*/_createTextVNode("Upload the "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, [
    /*#__PURE__*/_createElementVNode("b", null, "back")
  ]),
  /*#__PURE__*/_createTextVNode(" of your document")
], -1)
const _hoisted_20 = {
  class: "w-100 h-350px image-input image-input-outline",
  "data-kt-image-input": "true",
  style: {"background-image":"url(media/avatars/blank.png)"}
}
const _hoisted_21 = { class: "d-flex p-2 justify-content-center" }
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 1,
  class: "d-flex justify-content-center h-300px w-350px"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-file-image" })
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, [
  /*#__PURE__*/_createTextVNode(" Upload the "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, [
    /*#__PURE__*/_createElementVNode("b", null, "back")
  ]),
  /*#__PURE__*/_createTextVNode(" of your document ")
], -1)
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = {
  class: "btn btn-icon btn-circle btn-active-color-primary bg-white shadow",
  "data-kt-image-input-action": "change",
  "data-bs-toggle": "tooltip",
  title: "Change avatar",
  ref: "backRef"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-fill fs-7" }, null, -1)
const _hoisted_29 = ["value"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  name: "avatar_remove"
}, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x fs-2" }, null, -1)
const _hoisted_32 = [
  _hoisted_31
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_ErrorMessage, {
        name: "official_doc",
        class: "fv-plugins-message-container invalid-feedback"
      }),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "dropzone",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.triggerFrontUpload && _ctx.triggerFrontUpload(...args)))
          }, [
            (_ctx.official_doc)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.official_doc,
                  class: "img-fluid-kyc",
                  alt: "passport preview"
                }, null, 8, _hoisted_7))
              : _createCommentVNode("", true),
            (!_ctx.official_doc)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("label", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("input", {
            id: "official_doc",
            name: "official_doc",
            value: _ctx.official_doc_reset,
            type: "file",
            accept: ".png, .jpg, .jpeg",
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeFrontImage && _ctx.changeFrontImage(...args)))
          }, null, 40, _hoisted_14),
          _hoisted_15
        ], 512),
        _createElementVNode("span", {
          class: "btn btn-icon btn-circle btn-active-color-primary bg-white shadow",
          "data-kt-image-input-action": "remove",
          "data-bs-toggle": "tooltip",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.removeImage(1))),
          title: "Remove avatar"
        }, _hoisted_17)
      ]),
      _createVNode(_component_Field, {
        style: {"display":"none"},
        name: "official_doc.src",
        class: "form-control form-control-lg form-control-solid",
        modelValue: _ctx.formData.official_doc.src,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.official_doc.src) = $event))
      }, null, 8, ["modelValue"])
    ]),
    (_ctx.showBack)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _hoisted_19,
          _createVNode(_component_ErrorMessage, {
            name: "official_doc.src",
            class: "fv-plugins-message-container invalid-feedback"
          }),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", {
                class: "dropzone",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.triggerBackUpload && _ctx.triggerBackUpload(...args)))
              }, [
                (_ctx.official_doc_back)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.official_doc_back,
                      class: "img-fluid-kyc",
                      alt: "passport preview"
                    }, null, 8, _hoisted_22))
                  : _createCommentVNode("", true),
                (!_ctx.official_doc_back)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_26))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("label", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("input", {
                id: "official_doc_back",
                name: "official_doc_back.src",
                value: _ctx.official_doc_back_reset,
                type: "file",
                accept: ".png, .jpg, .jpeg",
                onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.changeBackImage && _ctx.changeBackImage(...args)))
              }, null, 40, _hoisted_29),
              _hoisted_30
            ], 512),
            _createElementVNode("span", {
              class: "btn btn-icon btn-circle btn-active-color-primary bg-white shadow",
              "data-kt-image-input-action": "remove",
              "data-bs-toggle": "tooltip",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.removeImage(2))),
              title: "Remove avatar"
            }, _hoisted_32)
          ]),
          _createVNode(_component_Field, {
            style: {"display":"none"},
            name: "official_doc_back.src",
            class: "form-control form-control-lg form-control-solid",
            modelValue: (_ctx.formData.official_doc_back || {}).src,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (((_ctx.formData.official_doc_back || {}).src) = $event))
          }, null, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true)
  ]))
}